<template>
  <div class="video-room row">
    <UserVideoComponent/>
    <UserVideoComponent/>
  </div>
</template>

<script>
import UserVideoComponent from './UserVideoComponent'

export default {
  name: 'VideoRoom',
  components: {
    UserVideoComponent,
  },
  data () {
    return {
      msg: 'video-room'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoRoom.vue